<template>
  <div class="modal-window">
    <section class="form">
      <w-form
        v-win-loading="loading"
        ref="planForm"
        :rules="rules"
        :model="formData"
        label-width="120px"
        label-align="right"
      >
        <w-form-item label="超期场景：" prop="PlanShowList">
          <div>{{ formData.CJMC }}</div>
        </w-form-item>
        <w-form-item label="超期时长(天)：" prop="CQTS">
          <div>{{ formData.CQTS }}</div>
        </w-form-item>
        <w-form-item label="申请内容：" prop="SQNR">
          <div>{{ formData.SQNR }}</div>
        </w-form-item>
        <w-form-item label="申请原因：" prop="SQYY">
          <w-input
            v-model="formData.SQYY"
            type="textarea"
            :autosize="{
              minRows: 6,
              maxRows: 8
            }"
            :maxlength="1000"
          >
          </w-input>
        </w-form-item>
        <w-form-item label="申请部门：" prop="SQBM">
          <!-- <div>{{ UserInfo.BQ_MC }}</div> -->
          <w-select v-model="formData.SQBM">
            <w-option
              v-for="item in ZZJGList"
              :key="item.ZZJGDM"
              :label="item.ZZJGMC"
              :value="item.ZZJGDM"
            ></w-option>
          </w-select>
        </w-form-item>
        <w-form-item label="申请人：">
          <div>{{ UserInfo.UserName + '(' + UserInfo.UserId + ')' }}</div>
        </w-form-item>
      </w-form>
      <div class="line"></div>
    </section>
    <div class="modal-window-footer">
      <div class="window-footer-btns">
        <w-button @click="exit()"> 取消 </w-button>
        <w-button type="primary" @click="saveSubmit()"> 提交 </w-button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'DetailDialog',
  props: {
    dataList: {
      type: Object,
      default: () => {
        return {}
      }
    },
    sqnr: {
      type: String,
      default: ''
    },
    row: {
      type: Object,
      default: () => {
        return {}
      }
    },
    hospCode:{
      type: String,
      default: ''
    }
  },
  data() {
    return {
      loading: false,
      rules: {
        SQYY: [
          {
            required: true,
            message: '请输入申请原因',
            trigger: 'change'
          }
        ],
        SQBM: [
          {
            required: true,
            message: '请选择申请部门'
          }
        ]
      },
      formData: {
        CJMC: '',
        CQTS: '',
        SQNR: '',
        SQYY: '',
        SQBM: ''
      },
      UserInfo: {},
      ZZJGList: [],
      rwlxList: [
        { selectionCode: '1', selectionName: '检查任务检查超期' },
        { selectionCode: '2', selectionName: '检查问题修改/删除超期' },
        { selectionCode: '3', selectionName: '检查问题下发超期' },
        { selectionCode: '4', selectionName: '检查问题整改超期' },
        { selectionCode: '5', selectionName: '质量改进评价超期' }
      ]
    }
  },
  computed: {
    HospitalCode() {
      return this.$store.state.user.HospitalCode
    }
  },
  created() {
    this.UserInfo = this.$store.state.user.loginUserInfo
  },
  mounted() {
    this.getDataList()
    this.getUserZZJGList()
    this.getOverTimeDays()
  },
  methods: {
    getOverTimeDays() {
      this.loading = true
      var rwlxObj = this.rwlxList.find(
        (i) => i.selectionName == this.formData.CJMC
      )
      let Rwlx = rwlxObj ? rwlxObj.selectionCode : 2
      let params = {
        Cfxh: this.row.CFXH,
        Rwbh:
          Rwlx == '1'
            ? this.row.CFXH
            : Rwlx == '2' || Rwlx == '3'
            ? this.row.KFXDM
            : Rwlx == '4'
            ? this.row.WTXH
            : this.row.PLFXDM,
        Rwlx,
        IsAudit: '0',
        HospitalCode: this.HospitalCode
      }
      this.$requestApi('GetOverTimeDays', params)
        .then((res) => {
          if (res.success) {
            this.formData.CQTS = res.data
          }
        })
        .finally(() => {
          this.loading = false
        })
    },
    getUserZZJGList() {
      this.$requestApi('GetUserZzjgAndZkzList', {}).then((res) => {
        if (res.success) {
          this.ZZJGList = res.data.map((item) => {
            return {
              ZZJGDM: item.id,
              ZZJGMC: item.name
            }
          })
          this.formData.SQBM = this.ZZJGList[0].ZZJGDM
        }
      })
    },
    getDataList() {
      this.formData.CJMC = this.dataList.CJMC ? this.dataList.CJMC + '超期' : ''
      this.formData.SQNR = this.sqnr + '申请'
    },
    // 保存
    saveSubmit() {
      this.$refs.planForm.validateForm((valid) => {
        if (valid) {
          let RWLX = this.rwlxList.find(
            (i) => i.selectionName == this.formData.CJMC
          ).selectionCode
          this.$requestApi('SaveCqsq', {
            CFXH: this.row.CFXH || '',
            CJDM: RWLX,
            CJMC: this.formData.CJMC,
            RWBH:
              RWLX == '1'
                ? this.row.CFXH
                : RWLX == '2' || RWLX == '3'
                ? this.row.KFXDM
                : RWLX == '4'
                ? this.row.WTXH
                : this.row.PLFXDM, // 检查拆分序号 下发/修改、删除kfxdm 评价/整改 wtxh
            RWLX,
            SQBM: this.formData.SQBM,
            SQBMMC: this.ZZJGList.find((i) => i.ZZJGDM == this.formData.SQBM)
              .ZZJGMC,
            SQR: this.UserInfo.UserId,
            SQRMC: this.UserInfo.UserName,
            SQNR: this.formData.SQNR,
            SQYY: this.formData.SQYY,
            CLZT: 0,
            BZ: '',
            HospitalCode: this.HospitalCode || this.hospCode
          }).then((res) => {
            if (res.success) {
              this.$msg('保存成功', 'success')
              this.$emit('close')
            }
          })
        }
      })
    },
    exit() {
      this.$comfirm('确定要取消本次操作吗？', {
        showCancelButton: true,
        cancelButtonText: '取消',
        confirmButtonText: '确定'
      }).then(() => {
        this.$emit('close')
      })
    }
  },
  windowConfigs: {
    maxButton: false,
    width: document.body.clientWidth,
    height: document.body.clientHeight
  }
}
</script>
<style lang="scss" scoped>
.form {
  margin-bottom: 40px;
  .w-form-item {
    min-height: 32px;
  }
}
.table-title {
  font-size: 13px;
  color: #666;
  margin: 5px 0;
  font-weight: bold;
}
.arrow {
  cursor: pointer;
}
.window-footer-btns {
  float: right;
}
</style>
